import React from 'react';

/**
 * Mobile wrapper for EditBookingModal.
 *
 * EditBookingModal already has full isMobile support built in:
 *  - Full-screen overlay (no rounded card)
 *  - Horizontal scrollable pill-style tab selector
 *  - Single-column responsive grids
 *  - Full-width payment/action buttons
 *
 * This wrapper simply passes all props through to the DesktopModalComponent,
 * which auto-detects mobile via useIsMobile() internally.
 */
function MobileEditBookingModalWrapper({
  booking,
  user,
  onClose,
  onUpdate,
  canCheckIn,
  canCheckOut,
  DesktopModalComponent,
}) {
  if (!DesktopModalComponent) {
    return null;
  }

  return (
    <DesktopModalComponent
      booking={booking}
      user={user}
      onClose={onClose}
      onUpdate={onUpdate}
      canCheckIn={canCheckIn}
      canCheckOut={canCheckOut}
    />
  );
}

export default MobileEditBookingModalWrapper;
